import { UserRoles } from '@shared/types/auth';

export const rolesMap: Record<
  UserRoles,
  {
    label: string;
    value: UserRoles;
  }
> = {
  [UserRoles.IMAGING_SPECIALIST]: {
    label: 'Imaging Specialist',
    value: UserRoles.IMAGING_SPECIALIST,
  },
  [UserRoles.SITE]: {
    label: 'Site User',
    value: UserRoles.SITE,
  },
  [UserRoles.USER]: {
    label: 'User',
    value: UserRoles.USER,
  },
  [UserRoles.ADMIN]: {
    label: 'Admin',
    value: UserRoles.ADMIN,
  },
  [UserRoles.SPONSOR]: {
    label: 'Sponsor',
    value: UserRoles.SPONSOR,
  },
  [UserRoles.DATA_MANAGER]: {
    label: 'Data Manager',
    value: UserRoles.DATA_MANAGER,
  },
  [UserRoles.PROJECT_MANAGER]: {
    label: 'Project Manager',
    value: UserRoles.PROJECT_MANAGER,
  },
  [UserRoles.READER]: {
    label: 'Reader',
    value: UserRoles.READER,
  },
  [UserRoles.SUPPORT]: {
    label: 'Support',
    value: UserRoles.SUPPORT,
  },
  [UserRoles.VALIDATION_SPECIALIST]: {
    label: 'Validation Specialist',
    value: UserRoles.VALIDATION_SPECIALIST,
  },
  [UserRoles.EXTERNAL_USER]: {
    label: 'External User',
    value: UserRoles.EXTERNAL_USER,
  },
};

export const userRoles = [
  rolesMap[UserRoles.IMAGING_SPECIALIST],
  rolesMap[UserRoles.SITE],
  rolesMap[UserRoles.ADMIN],
  rolesMap[UserRoles.SPONSOR],
  rolesMap[UserRoles.PROJECT_MANAGER],
  rolesMap[UserRoles.READER],
  rolesMap[UserRoles.SUPPORT],
  rolesMap[UserRoles.VALIDATION_SPECIALIST],
  rolesMap[UserRoles.EXTERNAL_USER],
];

export const supportedUiRoles = [
  rolesMap[UserRoles.IMAGING_SPECIALIST],
  rolesMap[UserRoles.SITE],
  rolesMap[UserRoles.SPONSOR],
  rolesMap[UserRoles.PROJECT_MANAGER],
  rolesMap[UserRoles.READER],
  rolesMap[UserRoles.SUPPORT],
  rolesMap[UserRoles.VALIDATION_SPECIALIST],
  rolesMap[UserRoles.EXTERNAL_USER],
];

export const filteredSupportedUiRoles = [
  rolesMap[UserRoles.IMAGING_SPECIALIST],
  rolesMap[UserRoles.SITE],
  rolesMap[UserRoles.SPONSOR],
  rolesMap[UserRoles.PROJECT_MANAGER],
  rolesMap[UserRoles.READER],
  rolesMap[UserRoles.VALIDATION_SPECIALIST],
  rolesMap[UserRoles.EXTERNAL_USER],
];

export enum TeamRoles {
  'SPONSOR' = 'SPONSOR',
  'READER' = 'READER',
  'PROJECT_MANAGER' = 'PROJECT_MANAGER',
  'SITE' = 'SITE',
  'IMAGING_SPECIALIST' = 'IMAGING_SPECIALIST',
  'SUPPORT' = 'SUPPORT',
  'VALIDATION_SPECIALIST' = 'VALIDATION_SPECIALIST',
  'EXTERNAL_USER' = 'EXTERNAL_USER',
}
